module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/aaf46bc6028bf524feb99328641419dd.png";